export default [

     {
          path: '/kpireviwer',
          name: 'KPIReviwer',
          component: () => import("@/modules/kpi/views/Page/KPIReviwer/KPIReviwer.vue"),
           meta: {
               title: 'KPIReviwer',
          },
     }
];